module.exports = __webpack_public_path__ + "static/media/SMotorAI.0460fc77.jpeg";